'use client';

import React from 'react';
import { Avatar, Chip, Link } from '@heroui/react';
import { RevshareSubscriber } from '../types';
import { getCampaignTypeColors } from '../constants';
import { OnlyFansIc } from '../../../../components/icons';

interface CampaignCellProps {
  subscriber: RevshareSubscriber;
}

const CampaignCell: React.FC<CampaignCellProps> = ({ subscriber }) => {
  const { model, company } = subscriber;
  const typeColors = getCampaignTypeColors();

  // Determine campaign type based on company.type
  const campaignType = company?.type === 'refshare' ? 'RevShare' : 'CPL';
  const typeStyle = typeColors[campaignType as keyof typeof typeColors] || typeColors.CPL;

  // Format date from created_at
  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  // Extract campaign code from link (e.g., "c168" from "https://onlyfans.com/yoooourmaid/c168")
  const getCampaignCode = (link?: string) => {
    if (!link) return '';
    const parts = link.split('/');
    return parts[parts.length - 1] || '';
  };

  const campaignCode = getCampaignCode(company?.link).slice(-4);
  const username = model?.of_user_name || '';
  const avatar = model?.avatar || '';
  const date = formatDate(company?.created_at);

  return (
    <div className="flex items-center gap-4">
      <Avatar src={avatar} className="w-10 h-10 rounded-3" radius="lg" />
      <div className="flex flex-col gap-1">
        {/* Row 1: Name and username */}
        <div className="flex items-center gap-2">
          <span className="text-auth-ink text-sm font-medium">{campaignCode}</span>
          {username && (
            <Link
              href={`https://onlyfans.com/${username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-partner text-sm font-normal"
            >
              @{username}
            </Link>
          )}
        </div>
        {/* Row 2: Type tag and platform */}
        <div className="flex items-center gap-2">
          <Chip
            size="sm"
            classNames={{
              base: `${typeStyle.bg} h-6 px-2`,
              content: `${typeStyle.text} text-xs font-normal p-0`,
            }}
          >
            {campaignType}
          </Chip>
          <Chip
            size="sm"
            variant="bordered"
            classNames={{
              base: 'h-6 px-2 border-[1.4px] border-zinc-300',
              content: 'text-auth-ink text-xs font-normal p-0 flex items-center gap-0.5',
            }}
          >
            <OnlyFansIc className="w-3.5 h-3.5" />
            <span>OnlyFans {date}</span>
          </Chip>
        </div>
      </div>
    </div>
  );
};

export default CampaignCell;
